import { useQuery } from '@tanstack/react-query';

import { QueryFunction, useRequest } from '@frontend/api';

import type {
  GetQuoteHeaderQueryKeyType,
  LiteQuote,
  QuoteHeaderByNumberParams,
} from './types';
import { getQuoteHeaderByNumberQueryKey } from './utils';

export const useGetQuoteHeaderByNumber: QueryFunction<
  LiteQuote,
  [QuoteHeaderByNumberParams],
  GetQuoteHeaderQueryKeyType
> = (params, { requestOptions, queryOptions } = {}) => {
  const { numberAndRevisionNumber } = params;
  const request = useRequest(requestOptions);
  const queryKey = getQuoteHeaderByNumberQueryKey(numberAndRevisionNumber);

  return useQuery({
    ...queryOptions,
    refetchOnWindowFocus: false,
    staleTime: 10 * 1000, // 10 seconds to prevent refetching when creating
    queryKey,
    queryFn: ({ signal }) => {
      return request(`/quotes/by_number/${numberAndRevisionNumber}/header`, {
        init: {
          method: 'GET',
          signal,
        },
      });
    },
  });
};
